import { render, staticRenderFns } from "./gpc-banner-appearance-card.vue?vue&type=template&id=9fb42c2c"
import script from "./gpc-banner-appearance-card.vue?vue&type=script&lang=js"
export * from "./gpc-banner-appearance-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports